module.exports = __webpack_public_path__ + "static/media/ContactLeft_VN.85a8afb4.png";